package ru.it_mozaika.sender.js.application.components.campaigns

import io.ktor.client.call.*
import io.ktor.client.statement.*
import io.ktor.http.*
import kotlinx.browser.document
import kotlinx.browser.window
import mui.icons.material.Cancel
import mui.material.*
import mui.material.Size
import mui.system.responsive
import mui.system.sx
import react.*
import ru.it_mozaika.sender.common.models.EmailMessageStatus
import ru.it_mozaika.sender.js.application.context.BackdropContext
import web.cssom.*

external interface CampaignsStatusDialogProps: Props{
    var onClose: () -> Unit
    var isOpen: Boolean
    var campaign: String
}

val campaignsStatisticsDownloadDialog = FC<CampaignsStatusDialogProps> {props ->

    val (selected, setSelected) = useState<List<Int>>(listOf())
    val backdrop = useContext(BackdropContext)
    Dialog{
        sx{margin = 5.px}
        this.open = props.isOpen
        DialogTitle{
            + "Выберите статусы событий по которым Вам необходима статистика"
        }
        DialogContent{
            FormControl {

                sx {
                    minWidth = 200.px
                    margin = 5.px
                }
                fullWidth = true
                InputLabel {
                    id = "subscription-list-select-label"
                    +"Статусы"
                }
                Select {
                    labelId = "events-status-list-select-label"
                    id = "events-status-list-select"
                    value = selected.toTypedArray()
                    label = ReactNode("Статусы: ")
                    multiple = true
                    onChange = onChange@{ e, _ ->
                            val ids = e.target.value.unsafeCast<Array<Int>>()
                            setSelected(ids.toSet().toList())

                    }
                        renderValue = useMemo(selected) {
                            { _ ->
                                Box.create {
                                    sx {
                                        display = Display.flex
                                        flexWrap = FlexWrap.wrap
                                        asDynamic().gap = 0.5
                                    }

                                    selected.forEach { status ->
                                        Chip {
                                            deleteIcon = Cancel.create {
                                                onMouseDown = {
                                                    it.stopPropagation()
                                                }
                                            }
                                            onDelete = {
                                                setSelected {
                                                    it.minus(status)
                                                }
                                            }

                                            key = status.toString()
                                            label = ReactNode(EmailMessageStatus.titles[status])
                                        }
                                    }
                                }
                            }
                        }


                    EmailMessageStatus.titles.forEach { (status, title) ->
                        MenuItem {
                            this.selected = selected.contains(status)
                            value = status
                            +title
                        }
                    }
                }
            }

        }
        DialogActions{
            Stack {
                direction = responsive(StackDirection.row)
                asDynamic().spacing = 2
                Button {
                    disabled = selected.isEmpty()
                    variant = ButtonVariant.outlined
                    size = Size.small
                    color = ButtonColor.secondary
                    onClick = {
                        props.onClose()
                        backdrop.show()
                        val url = URLBuilder("${window.location.protocol}${window.location.host}/api/v1/emails/excel")
                        url.parameters.appendAll("status", selected.map { it.toString() } )
                        url.parameters.append("campaign", props.campaign)
                        val element = document.createElement("a")
                        element.setAttribute("href", url.toString())
                        document.body?.appendChild(element)
                        @Suppress("UnsafeCastFromDynamic")
                        element.asDynamic().click()
                        backdrop.hide()

//                        Http.post(
//                            path = "/emails/excel",
//                            body = selected,
//                            query = mapOf("campaign" to props.campaign),
//                            callback = {response ->
//                                val fileName = response.headers["file"]
//                                if (fileName != null) {
//                                    val element = document.createElement("a")
//                                    val blob =
//                                        Blob(response.readBytes().toTypedArray(), jso { this.type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" })
//                                    element.setAttribute("href", URL.createObjectURL(blob))
//                                    element.setAttribute("download", fileName)
//                                    document.body?.appendChild(element)
//                                    element.asDynamic().click()
//                                    document.body?.removeChild(element)
//                                }
//
//                                backdrop.hide()
//
//                            }
//                        )

                    }
                    +"Скачать"
                }

                Button {
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                    +"Отмена"
                }
            }
        }
    }

}